<mat-sidenav-container class="h-screen w-screen" data-cy="history-sheet-container">
  <mat-sidenav
    class="w-full max-w-[420px]"
    position="end"
    mode="over"
    data-cy="history-sidenav"
    [opened]="sheet.opened()"
    (openedChange)="onOpenedChange($event)"
    (closed)="sheet.markClosed()"
  >
    @if (sheet.rendered()) {
      <app-history-sheet [source]="sheet.source()" (closed)="sheet.close()" />
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content />
  </mat-sidenav-content>
</mat-sidenav-container>
